import type { ICustomerImpactResponseDto } from 'generated/cxp-backend';

interface ICustomerImpactSuccessResolution {
    isStructuredFamilyResponse: boolean;
    matchesSelectedRequest: boolean;
    parentCreated: boolean;
}

export const resolveCustomerImpactSuccess = (
    response: ICustomerImpactResponseDto | undefined,
    selectedRequestId: string | undefined
): ICustomerImpactSuccessResolution => {
    const isStructuredFamilyResponse = !!response?.outcomes?.length;
    if (isStructuredFamilyResponse) {
        return {
            isStructuredFamilyResponse: true,
            matchesSelectedRequest: response?.originalRequestId === selectedRequestId,
            parentCreated: !!response?.parentCreated
        };
    }

    return {
        isStructuredFamilyResponse: false,
        matchesSelectedRequest: response?.id === selectedRequestId,
        parentCreated: response?.id !== selectedRequestId
    };
};
